import React, { Component } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import "./Shared.css";

import Login from "./Login";
import Loading from "./Loading";

class Authenticated extends Component {
  constructor(props) {
    super(props);

    this.auth = getAuth();
    this.state = {
      loading: this.auth.currentUser === null,
      user: this.auth.currentUser,
    }
  }

  componentDidMount() {
    if (!this.state.user?.uid) {
      onAuthStateChanged(this.auth, (user) => {
        if (user) {
          this.setState({loading: false, user: user});
        } else {
          this.setState({loading: false, user: null});
        }
      });
    }
  }

  setUser = (user) => {
    this.setState({user});
  }

  render() {
    if (this.state.loading && !this.props.silent) {
      return <Loading />;
    } else if (!this.state.loading && this.state.user?.uid) {
      return (this.props.render(this.state.user));
    } else if (this.props.required) {
      return (<Login setUser={this.setUser} />);
    } else if (this.props.unauth) {
      return (this.props.unauth());
    } else {
      return <div></div>;
    }
  }
}

export default Authenticated;
